module.exports = __webpack_public_path__ + "img/about-icon-3.94e0b5f3.svg";